
import { TRANSPARENT_IMAGE_URL } from '@/constants/IMAGE_URLS';

export default {
  i18nComponentKey: 'ProductReviewsMediaCollage.components.ZoomedMediumPc',
  name: 'ZoomedMediumPc',
  props: {
    review: {
      type: Object,
      required: true
    },
    mediaPosition: {
      type: Number,
      required: true
    }
  },
  computed: {
    videoSrc() {
      const videoIdx = this.mediaPosition ? this.mediaPosition - 1 : 0;
      return this.review.videos[videoIdx]?.url;
    },
    imageSrc() {
      const imageIdx = this.mediaPosition
        ? this.mediaPosition - this.review.videos.length - 1
        : 0;
      return this.review.images[imageIdx]?.url || TRANSPARENT_IMAGE_URL;
    }
  }
};
